import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';
// Components
import App from '../../../components/app';
import EnhancedTable from '../../../components/table';
import { HeadCell } from '../../../local-types';
// Modules
import { tableRequestPoints } from '../../../redux/reducers/table/module';
// Ressources
import { AccountRight } from '../../../utils/userUtils';
import { Cell, createCell } from '../../../components/table/table-cell-creator';

const queryString = require('query-string');

interface CreditBillProps extends WithTranslation, RouteComponentProps {}

class CreditBillListPage extends React.Component<CreditBillProps> {
    filterParams: any;

    constructor(props: CreditBillProps) {
        super(props);

        this.filterParams = queryString.parse(this.props.location.search);
    }

    headerBuilder = (): HeadCell[] => {
        const { t } = this.props;

        const cells: Cell[] = [
            Cell.BILL_NUMBER,
            Cell.BILL_DOCUMENT_PATH,
            Cell.BILL_RELATED_BILL_NUMBER,
            Cell.BILL_CREATED_AT,
            Cell.USER_ID,
            Cell.COMPANY_ID,
            Cell.RIDE_NUMBER,
            Cell.LABEL,
            Cell.AMOUNT_PRE_TAX,
            Cell.AMOUNT_WITH_TAX,
        ];

        return cells.map((cell) => createCell(t, cell)).filter((header) => header !== null) as HeadCell[];
    };

    render() {
        const { t } = this.props;

        return (
            <App
                needRights={{ name: AccountRight.CREDIT_NOTE_MGMT }}
                disableBreadcrumb
                header={{ title: t('title_credit') }}
            >
                <EnhancedTable
                    headers={this.headerBuilder()}
                    type={tableRequestPoints.BILLS_CREDITS_BETA}
                    filterParams={this.filterParams}
                />
            </App>
        );
    }
}

export default withTranslation(['bill', 'common'])(CreditBillListPage);
